module.exports = __webpack_public_path__ + "static/media/appIcon.d71a7a1d.png";